<template>
  <div class="space-y-4">
    <ValidationProvider rules="required" name="name" slim vid="name">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Name </BaseFormLabel>
          <BaseFormInput type="text" v-model="formData.name" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>
    <ValidationProvider name="product type" rules="required" slim vid="productType">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Product Type </BaseFormLabel>
          <div>
            <BaseFormSelect
              v-model="formData.productType"
              :options="productTypeOptions"
              :disabled="disabled"
            />
          </div>
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';

export default {
  props: {
    disabled: Boolean,
  },
  data() {
    return {
      formData: {
        name: '',
        productType: null,
      },
      productTypeOptions: [
        { value: 'simple', label: 'Simple' },
        { value: 'virtual', label: 'Virtual' },
      ],
    };
  },
  methods: {
    getFormData() {
      return cloneDeep(this.formData);
    },
  },
};
</script>
